import * as React from 'react';
import {useCallback, useEffect, useRef, useState} from 'react';
import {getTopicItemlist, TopicModule, ItemQuery} from '@/services/pages/channel/channel.client';
import {useSearchParams} from '@/hooks/router';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import styles from './index.less';

interface Props {
    page: string;
    sfRef?: string;
    innerModel?: boolean; // 内部模块显示二级标题样式
    infos: TopicModule;
    channelBusinessLine?: string;
    onMoreClick?: () => void;
}

// eslint-disable-next-line complexity
const SelfTopicContentFlowSmall = ({infos, innerModel, onMoreClick, page, channelBusinessLine}: Props) => {

    const [size, setSize] = useState<number>(0);
    const sizeRef = useRef<number>(0);

    const [module, setModule] = useState<TopicModule>();
    const [itemQuery, setItemQuery] = useState<ItemQuery>({pageSize: 10, pageNo: 1});

    const param = useSearchParams();

    useEffect(
        () => {
            setModule(infos);
            const size = infos.moduleMaxRows || infos.itemList?.length || 0;
            const maxSize = size < (infos.itemList?.length || 0) ? size : (infos.itemList?.length || 0);

            // eslint-disable-next-line no-unused-expressions
            sizeRef.current === 0 ? setSize(maxSize) : null;
            // eslint-disable-next-line no-unused-expressions
            sizeRef.current === 0 ? sizeRef.current = maxSize : null;
            if (onMoreClick) {
                return;
            }
            setItemQuery({
                id: param.id,
                // eslint-disable-next-line camelcase
                sf_ch: param.sf_ch,
                moduleId: infos.moduleId,
                preview: param.preview,
                pageSize: 10,
                pageNo: 1,
            });
        },
        [infos]
    );

    const loadMore = useCallback(
        () => {
            if (onMoreClick) {
                onMoreClick();
                return;
            }
            const query = {
                // eslint-disable-next-line camelcase
                sf_ch: itemQuery?.sf_ch,
                id: param.id,
                pageNo: ++itemQuery.pageNo,
                pageSize: itemQuery.pageSize,
                moduleId: infos.moduleId,
            };
            setItemQuery(query);
        },
        []
    );

    const handleMoreClick = useCallback(
        infos => {
            const dataSize = infos.itemList?.length || 0;
            const nextMaxShowSize = sizeRef.current + 5;
            const value = dataSize > nextMaxShowSize ? nextMaxShowSize : dataSize;

            // eslint-disable-next-line no-unused-expressions
            !(dataSize < infos.count && dataSize === size)
                ? setSize(value)
                : null;
            // eslint-disable-next-line no-unused-expressions
            dataSize < infos.count && dataSize === sizeRef.current
                ? loadMore()
                : sizeRef.current = value;
        },
        []
    );

    const fetchItemList = async (
        id?: string, moduleId?: number, pageSize?: number,
        // eslint-disable-next-line camelcase
        pageNo?: number, sf_ch?: string, preview?: boolean
    ) => {
        if (!id || !moduleId || onMoreClick) {
            return;
        }
        try {
            const data = await getTopicItemlist({
                id: id,
                moduleId: moduleId,
                pageSize: pageSize || 10,
                pageNo: pageNo || 1,
                // eslint-disable-next-line camelcase
                sf_ch: sf_ch,
                preview: preview,
            });

            const list = [];
            module?.itemList && list.push(...module.itemList);
            list.push(...data.list);

            const appendModule = {
                moduleId: module?.moduleId,
                channelId: module?.channelId,
                moduleName: module?.moduleName,
                isShowTitle: module?.isShowTitle,
                moduleMaxRows: module?.moduleMaxRows,
                moduleEnName: module?.moduleEnName,
                moduleSubTitle: module?.moduleSubTitle,
                moduleMaxColumns: module?.moduleMaxColumns,
                moduleType: module?.moduleType,
                moduleStyle: module?.moduleStyle,
                count: data.count,
                moreUrl: module?.moreUrl,
                itemList: pageNo === 1 ? data.list : list,
            };

            setModule(appendModule);

            pageNo !== 1 ? handleMoreClick(appendModule) : null;

        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }
    };

    useEffect(
        () => {
            fetchItemList(itemQuery.id,
                itemQuery.moduleId,
                itemQuery.pageSize,
                itemQuery.pageNo,
                itemQuery?.sf_ch,
                itemQuery.preview);
        },
        [itemQuery]
    );

    const {navigateToUrl} = useJumpUrl();

    const handleClick = useCallback(
        (linkUrl?: string, flowInfo?) => {
            const urlParams = {
                linkUrl,
            };
            const logParams = {
                page: page,
                value: 'jump_neirong_danliexiaotu',
                channelId: infos?.channelId,
                pageType: channelBusinessLine,
                moduleId: infos?.moduleId,
                moduleName: infos?.moduleName,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: flowInfo?.itemId,
                    // eslint-disable-next-line camelcase
                    value_title: flowInfo?.title,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [channelBusinessLine, infos.channelId, infos.moduleId, infos.moduleName, page, navigateToUrl]
    );

    return (
        <div
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_neirong_danliexiaotu',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >

            {
                innerModel
                    ? (
                        <div>
                            {
                                (module?.isShowTitle === 1 && (module?.moduleName || module?.moduleSubTitle))
                                    ? (
                                        <div className={styles.innerTitleLeftContent}>

                                            <div
                                                className={styles.innerTitleLeft}
                                            />

                                            {
                                                module?.moduleName
                                                    ? (
                                                        <span className={styles.innerTitle}>
                                                            {module?.moduleName}
                                                        </span>
                                                    )
                                                    : null
                                            }
                                        </div>
                                    )
                                    : null
                            }

                        </div>
                    )
                    : (
                        <div>
                            {
                                (module?.isShowTitle === 1 && (module?.moduleName || module?.moduleSubTitle))
                                    ? (
                                        <div className={styles.titleContent}>
                                            <div>
                                                {
                                                    module?.moduleName
                                                        ? (
                                                            <span className={styles.title}>
                                                                {module?.moduleName}
                                                            </span>
                                                        )
                                                        : null
                                                }
                                                {
                                                    module?.moduleSubTitle
                                                        ? (
                                                            <span className={styles.subTitle}>
                                                                {module?.moduleSubTitle}
                                                            </span>
                                                        )
                                                        : null
                                                }
                                            </div>
                                            {
                                                module?.moreUrl
                                                    ? (
                                                        <img
                                                            src={'https://med-fe.cdn.bcebos.com/content-external-channel/rightDirect.png'}
                                                            className={styles.rightMoreArrow}
                                                            onClick={() => {
                                                                handleClick(module?.moreUrl);
                                                            }}
                                                        />
                                                    )
                                                    : null
                                            }
                                        </div>
                                    )
                                    : null
                            }
                        </div>
                    )
            }


            {
                module?.itemList?.map(
                    (flowInfo, index) => (
                        <div
                            key={flowInfo.itemId}
                            data-show={JSON.stringify({
                                'page': page,
                                'value': 'jump_neirong_danliexiaotu',
                                'pageSourceId': flowInfo.channelId,
                                'pageType': channelBusinessLine,
                                'valueId': flowInfo.itemId,
                                'valueTitle': flowInfo.title,
                                'valueType': VALUE_TYPE.ITEM,
                            })}
                        >
                            {
                                index < size

                                    ? (
                                        <div
                                            onClick={() => handleClick(flowInfo.fieldValue?.link, flowInfo)}
                                        >

                                            <div className={styles.itemParent}>

                                                <div className={
                                                    styles(
                                                        flowInfo.fieldValue?.image
                                                            ? styles.textContentMargin
                                                            : styles.textContent,
                                                        styles.commmon
                                                    )
                                                }
                                                >

                                                    <span className={styles.itemTitle}>
                                                        {flowInfo.fieldValue?.title}
                                                    </span>

                                                    <div
                                                        className={styles.desContent}
                                                    >
                                                        <div
                                                            className={styles.des}
                                                        >
                                                            <span className={styles.des}>
                                                                {flowInfo.fieldValue?.expertName}
                                                            </span>
                                                            <span className={styles.des}>
                                                                {flowInfo.fieldValue?.expertTitle}
                                                            </span>
                                                            <span className={styles.des}>
                                                                {flowInfo.fieldValue?.expertHospital}
                                                            </span>
                                                        </div>

                                                        {
                                                            flowInfo.fieldValue?.hospitalLevel
                                                                ? (
                                                                    <div className={styles.tagParent}>
                                                                        <span
                                                                            className={styles.tag}
                                                                        >
                                                                            {flowInfo.fieldValue?.hospitalLevel}
                                                                        </span>
                                                                    </div>
                                                                )
                                                                : null
                                                        }
                                                    </div>


                                                </div>

                                                {
                                                    flowInfo.fieldValue?.image
                                                        ? (
                                                            <div className={styles.imgSmallCardMargin}>
                                                                <img
                                                                    src={flowInfo.fieldValue.image}
                                                                    className={styles.imgSmallCard}
                                                                />

                                                                {
                                                                    flowInfo.fieldValue.type === 2
                                                                        ? (
                                                                            <div className={styles.imgSmallCardMargin}>
                                                                                <img
                                                                                    className={styles.playIcon}
                                                                                    src={'https://med-fe.cdn.bcebos.com/content-external-channel/play.png'}
                                                                                />
                                                                            </div>
                                                                        )
                                                                        : null
                                                                }
                                                            </div>
                                                        )
                                                        : null
                                                }

                                            </div>

                                            {
                                                index < (module?.count || 1) - 1
                                                    ? <div className={styles.line} />
                                                    : null
                                            }

                                        </div>
                                    )

                                    : null
                            }

                        </div>
                    )
                )
            }


            {
                // eslint-disable-next-line max-len
                (module?.itemList && ((module?.itemList.length || 0) > size && size > 0 || module?.itemList.length < (module?.count || 0)))
                    ? (
                        <div
                            className={styles.moreContent}
                            onClick={() => {
                                handleMoreClick(module);
                            }}
                        >

                            <span
                                className={styles.moreText}
                            >
                                展开更多
                            </span>

                            <img
                                src={'https://med-fe.cdn.bcebos.com/content-external-channel/more-down.png'}
                                className={styles.moreArrow}
                            />
                        </div>
                    )
                    : null
            }

        </div>
    );
};

export default SelfTopicContentFlowSmall;
